import { render, staticRenderFns } from "./TiledSprite.vue?vue&type=template&id=e6045b6e&lang=pug&"
import script from "./TiledSprite.vue?vue&type=script&lang=js&"
export * from "./TiledSprite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports